// Numeric columns hug their content; the first (name) column takes the slack. Theme cells have no horizontal padding.
// Rounded header: the tint moves from the row to the cells (rows can't be rounded) and borders stay separate.
export const reviewTableSx = {
  borderCollapse: "separate",
  borderSpacing: 0,
  "& .MuiTableCell-root": { px: 1.5, whiteSpace: "nowrap" },
  "& .MuiTableCell-root:first-of-type": { width: "100%", whiteSpace: "normal" },
  "& .MuiTableHead-root .MuiTableRow-root": { bgcolor: "transparent" },
  "& .MuiTableHead-root .MuiTableCell-root": { bgcolor: "mockup.primary95" },
  "& .MuiTableHead-root .MuiTableCell-root:first-of-type": {
    borderTopLeftRadius: "8px",
  },
  "& .MuiTableHead-root .MuiTableCell-root:last-of-type": {
    borderTopRightRadius: "8px",
  },
  // Inset column dividers like BasicTable's Cell; decorative, so WCAG 1.4.11 doesn't apply.
  "& .MuiTableBody-root .MuiTableCell-root": { position: "relative" },
  "& .MuiTableBody-root .MuiTableCell-root:not(:last-of-type)::after": {
    content: "''",
    position: "absolute",
    top: "12px",
    bottom: "12px",
    right: 0,
    width: "1px",
    bgcolor: "mockup.neutral90",
  },
}
